
import router from './../router'
import Router from './../router';

export const mutations = {
  setsliketest:(state,payload)=>{
    state.sliketest = payload
  },
  setporuceno:(state,payload)=>{
    if (payload == 'ok'){
      state.poruceno = true
    }
  },
  settestiranja:(state,payload)=>{
    state.testiranja = payload
  },
  settest:(state,payload)=>{
    state.test = payload
  },
  setsaveti:(state,payload)=>{
    state.saveti = payload
  },
  setsavet:(state,payload)=>{
    state.savet = payload
  },
  setkurs:(state,payload)=>{
    state.kurs = (payload.value * 1).toFixed(2)
  },
  setpropics:(state,payload)=>{
    state.propics = payload
  },
  setbrand:(state,payload)=>{
    state.brand = payload
  },
  setopis:(state,payload)=>{
    state.opis = payload
  },
  setsinglpk:(state,payload)=>{
    state.singlpk = payload
  },
  setpro:(state,payload)=>{
    state.pro = payload
  },
  setallpro:(state,payload)=>{
    state.allpro = payload
  },
  setallpak:(state,payload)=>{
    state.allpak = payload
  },
  setpak:(state,payload)=>{
    if(payload[0].pak_naziv){
    state.pak = payload
    state.pakname = payload[0].pak_naziv
    }

  },
  setpojedinacna:(state,payload)=>{
    state.pojedinacna = payload
  },
  setpodkategorije:(state,payload)=>{
    state.podkategorije = payload;
  },
  setppkategorije:(state,payload)=>{
    state.ppkategorije = payload;
  },
  setkategorije:(state,payload)=>{
    state.kategorije = payload;
  },

  setnaziv:(state,payload)=>{
    state.naziv = payload
  },
  setterms:(state,payload)=>{
    state.terms = payload
  },
  setkat:(state,payload)=>{
    state.kat = payload
  },
  setproname:(state,payload)=>{
    state.proname = payload
  },
  setopis:(state,payload)=>{
    state.opis = payload
  },

  setmanufectur:(state,payload)=>{
    state.manufectur = payload
  },
  setprava:(state,payload)=>{
    state.prava = payload
  },
  setuslovi:(state,payload)=>{
    state.uslovi = payload
  },
  setkolplus:(state,payload)=>{
    for (var i = 0; i < state.cart.length; i++) {
      if(state.cart[i].pro_id == payload.pro_id && state.cart[i].pakovanje == payload.pakovanje){
       state.cart[i].kolicina ++;
      }
    }
  },
  setkolminus:(state,payload)=>{
    for (var i = 0; i < state.cart.length; i++) {
      if(state.cart[i].pro_id == payload.pro_id && state.cart[i].pakovanje == payload.pakovanje){
       state.cart[i].kolicina --;

      }
    }
  },
removepro:(state,payload)=>{
  state.cart.splice(payload, 1)
},
clearcart:(state,payload)=>{
  state.cart =[]
  state.subtotal=0
  state.total=0
  // state.shipping=0
  // console.log(state.cart);
},

changecart:(state,payload)=>{
  for (var i = 0; i < state.cart.length; i++) {

    if(state.cart[i].pro_id == payload.pro_id && state.cart[i].pakovanje == payload.pakovanje){

     state.cart[i].kolicina = payload.kolicina
    }
  }


},
setcart:(state,payload)=>{
  state.cart.push(payload)
},
setedit:(state,payload)=>{
  state.edit=payload
},
seteditpro:(state,payload)=>{
  state.singlpro=payload.singlpro[0]
  state.singlpics=payload.pics
},
settotal:(state,payload)=>{
    state.subtotal=0
    payload.forEach((i) =>{
      var sum = i.cena * i.kolicina * state.kurs
      var stari = state.subtotal
     state.subtotal = stari+ sum;
         // if(state.subtotal >5000){
         //   state.shipping = 0
         // }
    });
    var isporuka = 0
    var svega = 0
     // isporuka += parseInt(state.shipping)
     svega +=parseInt(state.subtotal)
    // state.total = svega + isporuka
    state.total = svega
},
// setml:(state,payload)=>{
//   state.ml = payload
// },
// seterror:(state,payload)=>{
//   if(payload){
//     if(state.lang =='eng'){
//       state.error ='NO PRODUCT MATCHES'
//     }
//     if(state.lang =='srb'){
//       state.error ='NEMA PROIZVODA PO ŽELJENOJ PRETRAZI'
//     }
//   }else {
//     state.error =''
//   }
//
//
// },
// setlang:(state,payload)=>{
//   state.lang = payload
// },


}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js